import Vue from 'vue'
import Component from 'vue-class-component'

declare const config: any

@Component
export default class ResultComponent extends Vue {
    resultSend: any
    steps: any
    webmailList: any
    emailsList: any
    webpagesList: any
    lang = 'EN'
    docLink = '';
    stepOneInfo = {
        from_alias: '',
        from_address: '',
        subject: null,
        preview: null,
        goodAnswer: false
    }

    stepTwoInfo = {
        legit: {
            id: null,
            from_alias: '',
            from_address: '',
            screenshots: []
        },
        goodAnswer: false,
        phishing: {
            id: null,
            from_alias: '',
            from_address: '',
            screenshots: []
        }
    }

    stepThreeInfo = {
        legit: {
            id: null,
            url: null,
            screenshots: []
        },
        goodAnswer: false,
        phishing: {
            id: null,
            url: null,
            screenshots: []
        }
    }

    screenSize = ''
    servUrl = ''
    star = 0
    minutes = '00'
    secondes = '00'
    param = {
        brand: 'string',
        domain: 'string',
        url: 'string'
    }

    brand = {
        name: 'string',
        domains: 'array',
        urls: 'array',
    }

    TextAccordingStars = [
        {
            title: 'training.TRY_AGAIN',
            text: 'result.DONT_GIVE_UP'
        }, {
            title: 'result.NICE_TRY',
            text: 'result.IT_NOT_PERFECT'
        }, {
            title: 'result.ALMOST_THERE',
            text: 'result.YOU_CANT_BE_TRICKED_THAT_EASILY'
        }, {
            title: 'result.PERFECT',
            text: 'result.YOURE_A_TRUE_PHISHING_EXPERT'
        }
    ]

    domainsList = {}
    urlsList = {}
    mobileMode = false
    innerWidth = 0

    created() {
        window.addEventListener('resize', this.onResize)
        this.servUrl = config.BASE_URL
        this.resultSend = JSON.parse(sessionStorage.getItem('result') || '{}')
        this.steps = JSON.parse(sessionStorage.getItem('steps') || '{}')
        const storedLang = sessionStorage.getItem('lang') || 'en'

        if (storedLang !== null) this.lang = storedLang.toUpperCase()

        if (this.lang === 'FR') {
            this.docLink = config.FR_DOC
        } else {
            this.docLink = config.EN_DOC
        }

        for (let i = 0; i < this.steps.length; i += 1) {
            if (this.steps[i].type === 'webmail') {
                this.webmailList = this.steps[i].samples
            }
            if (this.steps[i].type === 'emails') {
                this.emailsList = this.steps[i].samples
            }
            if (this.steps[i].type === 'webpages') {
                this.webpagesList = this.steps[i].samples
            }
        }

        for (let i = 0; i < this.resultSend.length; i += 1) {
            if (this.resultSend[i].goodAnswer) {
                this.star += 1
            }

            this.getData(this.resultSend[i].id, this.resultSend[i].response, this.resultSend[i].goodAnswer)
        }
        if (sessionStorage.getItem('brand')) {
            this.brand = JSON.parse(sessionStorage.getItem('brand') || '{}')
        }
        const url = new URL(this.brand.urls[0])
        this.param = {
            brand: this.brand.name,
            domain: this.brand.domains[0],
            url: url.hostname
        }
        this.domainsList = this.brand.domains
        this.urlsList = this.brand.urls

        this.getChrono()
        window.scrollTo(0, 0)
    }

    onResize(event?: any) {
        this.innerWidth = window.innerWidth
        if (this.innerWidth <= 980) {
            this.mobileMode = true
        } else {
            this.mobileMode = false
        }
    }

    getData(step: number, response: string, goodAnswer: boolean) {
        if (step === 1) {
            for (let i = 0; i < this.webmailList.length; i += 1) {
                if (this.webmailList[i].id === response) {
                    this.stepOneInfo = this.webmailList[i]
                    this.stepOneInfo.goodAnswer = goodAnswer
                }
            }
        } else if (step === 2) {
            for (let i = 0; i < this.emailsList.length; i += 1) {
                if (this.emailsList[i].id === response) {
                    this.stepTwoInfo.phishing = this.emailsList[i]
                    this.stepTwoInfo.goodAnswer = goodAnswer
                } else {
                    this.stepTwoInfo.legit = this.emailsList[i]
                }
            }
        } else {
            for (let i = 0; i < this.webpagesList.length; i += 1) {
                if (this.webpagesList[i].id === response) {
                    this.stepThreeInfo.phishing = this.webpagesList[i]
                    this.stepThreeInfo.goodAnswer = goodAnswer
                } else {
                    this.stepThreeInfo.legit = this.webpagesList[i]
                }
            }
        }
    }

    getImage(type: string, elmnt: any) {
        const screenshotArray = elmnt.screenshots
        let size

        if (this.mobileMode) {
            size = screenshotArray.find((element: any) => element.split('x')[0] < 960)
        } else {
            size = screenshotArray.find((element: any) => element.split('x')[0] > 960)
        }
        return `${this.servUrl}/${type}/${elmnt.id}/screenshots/${size}.png`
    }

    getStar(index: number) {
        if (this.star >= index) {
            return require('@/assets/img/star-white.svg')
        }
        return require('@/assets/img/star-blue.svg')
    }

    getCupWithStar() {
        switch (this.star) {
        case 0:
            return require('@/assets/img/cup-0-stars.svg')

        case 1:
            return require('@/assets/img/cup-1-stars.svg')

        case 2:
            return require('@/assets/img/cup-2-stars.svg')

        case 3:
            return require('@/assets/img/cup-3-stars.svg')

        default:
            return require('@/assets/img/cup-0-stars.svg')
        }
    }

    getChrono() {
        const startDate = new Date(JSON.parse(sessionStorage.getItem('start') || '{}')).getTime()
        const endDate = new Date(JSON.parse(sessionStorage.getItem('end') || '{}')).getTime()

        const diff = new Date(endDate - startDate)

        let minutes
        let secondes
        const min = diff.getMinutes()
        const sec = diff.getSeconds()
        if (min < 10) {
            minutes = `0${min}`
        } else {
            minutes = min
        }

        if (sec < 10) {
            secondes = `0${sec}`
        } else {
            secondes = sec
        }
        this.minutes = minutes.toString()
        this.secondes = secondes.toString()
    }

    goToInvite() {
        const sessionId = sessionStorage.getItem('session_id') || ''

        this.$router.push({
            name: 'InviteId',
            params: { id: sessionId }
        })
    }
}
